import React from 'react';
import { createPortal } from 'react-dom';

interface PortalProps {
  children: React.ReactNode;
  container?: Element | null;
}

/**
 * Portal component that renders children into a DOM node outside the parent hierarchy.
 * Similar to how shadcn/Radix UI handles dropdown positioning.
 * This solves overflow:hidden and z-index stacking context issues.
 */
export const Portal: React.FC<PortalProps> = (props) => {
  const { children, container } = props;

  if (typeof document === 'undefined') {
    return null;
  }

  const targetContainer = container || document.body;

  return createPortal(children, targetContainer);
};

Portal.displayName = 'Portal';
